import { Controller } from "@hotwired/stimulus"

export class EmailInputController extends Controller {
    connect() {
        this.normalize()
    }

    normalize() {
        const value = this.element.value.trim().toLowerCase()
        if (value === this.element.value) return
        this.element.value = value
        this.element.dispatchEvent(new Event("input", { bubbles: true }))
    }

    submitting(event) {
        if (event.target === this.element.form) this.normalize()
    }
}
